module.exports = __webpack_public_path__ + "static/img/solution_img_2.1c7b348.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_2.png
// module id = 8dkU
// module chunks = 22